var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 9.75C3.5125 9.75 2.3595 9.278 1.416 8.334C0.4725 7.39 0.000500397 6.237 3.96825e-07 4.875C-0.000499603 3.513 0.4715 2.36 1.416 1.416C2.3605 0.472 3.5135 0 4.875 0C6.2365 0 7.38975 0.472 8.33475 1.416C9.27975 2.36 9.7515 3.513 9.75 4.875C9.75 5.425 9.6625 5.94375 9.4875 6.43125C9.3125 6.91875 9.075 7.35 8.775 7.725L12.975 11.925C13.1125 12.0625 13.1813 12.2375 13.1813 12.45C13.1813 12.6625 13.1125 12.8375 12.975 12.975C12.8375 13.1125 12.6625 13.1813 12.45 13.1813C12.2375 13.1813 12.0625 13.1125 11.925 12.975L7.725 8.775C7.35 9.075 6.91875 9.3125 6.43125 9.4875C5.94375 9.6625 5.425 9.75 4.875 9.75ZM4.875 8.25C5.8125 8.25 6.6095 7.922 7.266 7.266C7.9225 6.61 8.2505 5.813 8.25 4.875C8.2495 3.937 7.9215 3.14025 7.266 2.48475C6.6105 1.82925 5.8135 1.501 4.875 1.5C3.9365 1.499 3.13975 1.82725 2.48475 2.48475C1.82975 3.14225 1.5015 3.939 1.5 4.875C1.4985 5.811 1.82675 6.608 2.48475 7.266C3.14275 7.924 3.9395 8.252 4.875 8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search_empty.db561231e18be97844253bd4c5ba380e.svg";
export { ForwardRef as ReactComponent };